import React from 'react'

const ApplySegmentWrapper = ({ children, componentClass }) => (
  <div className={`row p24 mr0 ml0 mobile-apply-padding pb0 ${componentClass}`}>
    {children}
  </div>
)

export default ApplySegmentWrapper
